import {Flex, Modal} from '@mantine/core'
import {AddForm} from '../forms/project/AddForm.tsx'

type Props = {
  opened: boolean
  onClose: () => void
}

export const AddProjectModal = ({opened, onClose}: Props) => {
  return (
    <Modal opened={opened} onClose={onClose} title={'Add project'} size={'lg'}>
      <Flex direction={'column'} gap={'sm'}>
        <AddForm onSuccess={onClose} disabled={false} />
      </Flex>
    </Modal>
  )
}
